export const API_URL = {
    device: {
        base: '/device',    // get-디바이스 목록, put, post, delete, {id}: get-상세조회, put
        command: '/device/command', // put-디바이스 재부팅
        powerManage: '/device/devicePowerManage',
        changeSort: '/device/changeSort',   // put-디바이스 순서 수정
        group: '/devicegroup',  // get, post, delete, {id}: put-디바이스 그룹 수정
        vncKey: '/device/vncKey', // {id}: post-디바이스 원격 vncKey 생성
        countByBrand: '/device/count-by-brand',
        remote: '/device/remote',
        pairing: {
            base: '/device/pairing',    // {id}: post-디바이스 pairing code 생성
            disconnect: '/device/pairing-disconnect',   // {id}: post-디바이스 pairing 해제
            connection: '/device/pairing-connection',   // post-디바이스 pairing 연결
            restoreRedis: '/device/devicePairingRestoreRedis'   // get-디바이스 페어링 Redis 정보 업데이트
        },
        contents: { // 디바이스 콘텐츠 관리
            base: '/device/contents',   // get, post, delete, {id}: get, put
            templates: '/device/shop-by-templates',   // get
            disconnect: '/device/contents-disconnect',  // post-디바이스 컨텐츠 연결 해제
            connection: '/device/contents-connection',  // post-디바이스 컨텐츠 연결
            deploy: {
                base: '/device/contents/deploy',    // {id}: post
                device: '/device/contents/deploy/device',   // get-콘텐츠 배포 기능 디바이스 조회
                contents: '/device/contents/deploy/contents'    // get-배포할 콘텐츠 선택 리스트 조회
            },
            mealCourse: '/meal/course/type'
        },
        screen: {
            log: '/deviceScreenLog' // get-스크린샵 조회, post
        },
        shop: 'device/shop-by-devices'
    },
    vnc: {
        base: 'vnc-manage',
        info: 'vnc-manage/vnc-info'
    },
    member: {   // 멤버
        base: '/member',    // get, delete-멤버삭제, {id}: get-상세 조회, put-수정
        me: '/member/me',
        tempPwd: '/member/temp-pwd',    // put-멤버 임시비밀번호 발급
        changePwd: '/member/change-pwd',    // put-멤버 비밀번호 수정
        resetPwd: '/member/reset-pwd',    // put-멤버 비밀번호 초기화
        sso: '/member/sso', // post-멤버 sso 로그인
        signUp: '/member/sign-up',  // post-멤버 가입
        signOut: '/member/sign-out',    // post-멤버 로그아웃
        signIn: '/member/sign-in',  // post-멤버 로그인
        refreshToken: '/member/refresh-token',  // post-멤버 토큰 재발급
        extendsPwdChangeDate: 'member/extend-pwd',
        invite: {
            base: '/member/invite',
            list: '/member/invite/list',
            shop: '/member/invite/shop'
        },   // post-멤버 초대, {brandCode}/{shopId}: get-멤버 초대 리스트, {brandCode}/{shopId}/{mailCode}: delete-멤버 초대 삭제
        addShop: '/member/add-shop',    // 멤버 매장 추가, post
        info: '/member/info',   // {brandCode}/{shopId}/{mainCode}: get-멤버 초대 정보 불러오기
        certify: '/member/certify-access', // put-개인정보 접근 인증
    },
    customer: {
        temp: {
            manualAdd: '/customerTemp/manualAdd',   // {brandId}: post-임직원 수기 등록
            excelAdd: '/customerTemp/excelAdd',     // {brandId}: post-임직원 엑셀 등록
            excelValid: '/customerTemp/excelAdd/valid',     // {brandId}: post-임직원 엑셀 서버 매칭
            downloadExcel: '/customerTemp/downloadExcelTemplate'    // get-임직원 등록 엑셀 템플릿 다운로드
        },
        internal: {
            base: '/customer/internal', // get-임직원 리스트, post-등록, delete
            count: '/customer/internal/count', // get-임직원 리스트, post-등록, delete
            state: '/customer/internal/state',  // {id}: put-상태정보 수정
            certify: '/customer/internal/certify',   // {id}: put- 이메일 인증 수정
            verify: '/customer/internal/verify', // post-메일발송, {brandCode}/{mainCode}: get-메일 인증
            log: '/customer/log', // 이력관리
            logBrand: '/customer/log/brand',
            logDownload: '/customer/log/download',
            initPassword: '/customer/internal/temp-pwd', // {id}: put-임직원 비밀번호 초기화
            simple: '/customer/internal/simple', // get-임직원 검색(간단)
        },
        external: {
            base: '/customer/external', // get-외부 인원 리스트 조회, post, delete
            detail: '/customer/external/detail', // get-외부 인원 상세 조회
            activationType: '/customer/external/activationType',    // {id}: put-외부인원 활성화 여부 수정
            rfid: '/customer/external/rfid', // get-rfid 중복 확인
            modAt: '/customer/external/modAt', // get-외부인원 수정일자 조회
            count: '/customer/external/count', // get-외부인원 사용/미사용 count, 수정일자 조회
        }
    },
    paymentReason: '/payment/reason',    // get-결제 사유 리스트, post, delete, {id}: get-결제 사유 상세 조회, put-결제 사유 수정
    robotZone: {
        base: '/robot/zone', // get-배송지역 리스트, post, delete, {id}: get-로봇 배송 지역 상세 조회, put-지역 수정
        km: '/robot/zone/km', // get-로봇 배송 지역 조회 km
        yn: '/robot/zone/activationYn', // get-로봇 배송 지역 조회 km
    },
    notice: {
        base: '/notice',  // get, post, delete, {id}: get-상세, put-수정
    },
    delivery: {
        robot: '/delivery/robot-delivery',  // get-로봇배달 설정 조회, post-저장
        reserved: {
            delivery: '/delivery/reserved-delivery',    // get-예약배달 설정 조회, post-저장
            pickup: '/delivery/reserved-pickup' // get-예약픽업 설정 조회, post-저장
        },
        zone: '/delivery-zone', // get-배송지역 리스트, post-등록, delete, {id}: get-상세, put-수정
    },
    goods: {
        base: '/goods', // get-상품 목록 조회, post, {goodsId}: get-상세, put-수정, /yn: put-사용 여부 수정, /soldout-yn: 강제 품절 여부, /robot-yn: 로봇 사용여부, /coupon-yn: 쿠폰 사용여부
        detail: '/goods/detail-list',
        withDisplay: '/goods/display-and-goods',
        copy: '/goods/copy', // post-상품 복사
        stock: {
            base: '/goods/stock',   // get, post, {goodsId}: get, put, /yn: put
            log: '/goods/stock/log',   // get - 입출 이력 조회
            download: '/goods/stock/download' //get - 재고 관리 엑셀 다운로드
        },
        display: {
            base: '/goods/display', // get-전시상품 목록, post-등록, {displayId}: get-상세, put-수정
            copy: '/goods/display/copy',  // post - 복사
            sortList: '/goods/display/sortList',  // get - 순서변경용 목록 조회
            sort: '/goods/display/changeSort',  // put - 순서변경
            categoryChange: '/goods/display/categoryChange',  // put - 순서변경
        },
        pos: '/goods/pos',  // get-pos 상품 조회
        option: {
            base: '/goods/option',  // get-옵션 조회, post-등록, delete, {optionId}: get-상세, put-수정, /yn: put-옵션 활성화 여부 변경
            detail: '/goods/option/detail', // get- 굿즈 옵션 리스트 상세
            sort: '/goods/option/changeSort', // sort
            selectList: '/goods/option/selectList', // get-옵션 선택 리스트 (상품판매통계 - 옵션별 활용)
        },
        category: {
            base: '/goods/category',
            sort: '/goods/category/sort',
            group: '/goods/group', // get 상품 목록 리스트
            groupList: '/goods/group/list' // get 상품 목록 리스트 no paging
        },    // get-카테고리 목록, post-등록, delete, {categoryId}: put-수정.
        order: {
            base: '/goods/order',   // post-주문취소(pos용)
            status: '/goods/order/status',  // post-매장 주문 상태 변경, {orderId}: get-키오스크, 모바일 주문상태 확인
            autoComplete: '/goods/order/autoComplete',  // post-진행중인 주문 자동완료
            previous: '/goods/order/previous-business-static',  // get-직전 영업일 정산 매출 통계 조회
            payment: {
                list: '/goods/order/paymentList',   // get-pos 결제내역 조회
                detail: '/goods/order/paymentDetail'    // get-pos 결제내역 상세
            },
            manage: '/goods/order/manage',   // get-주문관리
            lastSale: '/goods/order/last-sales-static'  // get-직전 영업시간 매출 통계 조회
        }
    },
    satis: {
        mobile: {
            base: '/satis/mobile',   // post-만족도 조사 등록, {satisMobileId}: get, put, delete
            tag: '/satis/mobile/tag',    // post, {satisMobileId}: get
            Participant: {
                list: '/satis/mobile/participant/list', // get-만족도 모바일 통계 조사 리스트
                listExcel: '/satis/mobile/participant/list/excel', // get-만족도 모바일 통계 조사 리스트
                item: '/satis/mobile/participant/item', // get-만족도 모바일 통계 항목별 통계
                itemGraph: '/satis/mobile/participant/item/graph', // get-만족도 모바일 통계 항목별 통계 - 그래프
                itemExcel: '/satis/mobile/participant/item/excel', // get-만족도 모바일 통계 항목별 통계
            },
        },
        kiosk: {
            base: '/satis/kiosk',   // post, {satisKioskId}: get, put, delete
            menu: {
                base: '/satis/kiosk/menu',  // post-만족도 조사 메뉴 등록/수정/삭제, {satisKioskId}: get, delete
                group: '/satis/kiosk/menu/group'    // post-만족도 조사 메뉴 그룹 등록
            },
            participant: {
                rank: '/satis/kiosk/participant/rank',  // get-만족도 조사 평점 순위 통계
                list: '/satis/kiosk/participant/list',  // get-만족도 조사 리스트 통계
                listExcel: '/satis/kiosk/participant/list/excel', // get-만족도 모바일 통계 조사 리스트
                item: '/satis/kiosk/participant/item',  // get-만족도 조사 항목별 통계
                itemGraph: '/satis/kiosk/participant/item/graph',  // get-만족도 조사 항목별 통계 - 그래프
                itemExcel: '/satis/kiosk/participant/item/excel', // get-만족도 모바일 통계 항목별 통계
            }
        }
    },
    scheduler: '/scheduler', // get-스케뷸러관리, post
    meal: {
        base: '/meal',  // get, post, delete, {mealId}: put
        course: {
            base: '/meal/course',  // get, post-식당 코드 저장, 수정
            date: '/meal/course/date',  // get-식당 코드 날짜별 조회
            sort: '/meal/course/sort',  // put {shopId}-식당 코드 정렬
        },
        operation: {
            time: '/meal/operation-time',   // get, post-운영시간 저장/수정, delete
            sort: '/meal/operation-time/changeSort',   // put {shopId}-운영시간 정렬
        },
        order: {
            base: '/meal/order',
        }
    },
    codeGroup: {
        base: '/code-group' // get-코드 그룹 리스트 조회, post-코드 그룹 등록/수정/삭제
    },
    company: {
        base: '/company',   // get-법인 리스트, post-등록, delete, {id}: get-상세, put-수정
        name: '/company/name'   // get-법인명 조회
    },
    externalService: {
        base: '/external-service',   // get-외부서비스 리스트, post-등록, delete, {id}: get-상세, put-수정
        name: '/external-service/name'   // get-외부서비스 조회
    },
    role: '/role',  // get-권한 리스트, post-권한 등록/수정/삭제
    menu: {
        base: '/menu',  // get-메뉴 리스트 조회, post-등록/수정/삭제, delete, {id}: put- 수정
        sub: '/menu/sub',    // get-메뉴 목록과 서브 메뉴 조회
        role: '/menu/role'  // get-롤 리스트, post-등록/수정/삭제, delete, {id}: put- 수정
    },
    enum: '/doc/enum',  // get, {enumClassName}: get
    shop: {
        base: '/shop',  // get, post, {shopId}: get, put, delete
        name: '/shop/name', // {shopIds}: get-매장명 조회
        list: '/shop/list', // {shopIds}: get-매장 리스트 조회
        type: '/shop/type',
        sale: {
            action: '/shop-sales-action',   // get-영업 기록 조회
            plan: {
                base: '/sales-plan',    // {shopId}/manual-open: put, /manual-close: put
                autoOnOff: '/sales-plan/auto-onoff-yn', // put
                cafe: {
                    base: '/sales-plan/cafe',   // put-영업 설정 수정, {shopId}: get
                    breaktime: '/sales-plan/cafe/breaktime',    // {shopId}: get-조회, post-등록, 수정
                    pause: '/sales-plan/cafe/pause-yn', // put
                    lastOrder: '/sales-plan/cafe/lastorder-yn', // put
                    breaktimeYn: '/sales-plan/cafe/breaktime-yn', // put
                },
                cafeteria: {
                    base: '/sales-plan/cafeteria',  // put-영업 설정 수정, {shopId}: get
                    dupTag: '/sales-plan/cafeteria/duptag-yn',   // put
                    congestion: '/sales-plan/cafeteria/congestion-yn'   // 혼잡도 사용유무 put
                }
            }
        }
    },
    config: '/config',  // get-조회, post-등록/수정/삭제
    survey: {
        base: '/survey',    // get-설문 조회, post-등록, delete, {surveyId}: get-상세, put-수정, /excelDownload: get-엑셀 다운로드
        close: '/survey/close'  // put-종료
    },
    space: {
        base: '/space',
        brandList: '/space/brand',
        popup: '/space/popup',
        target: '/space/target',
        allList: '/space/all',
        brandShop: '/space/brand-shop',
        shopCopy: '/shop/copy',
        shopCopyProgress: '/shop/copy/progress'
    },    // get, post, {spaceId}: get, put, delete
    manual: {
        base: '/manual',    // get-리스트, post-등록, delete, {id}: get-상세, put
        use: '/manual/use-yn',  // {id}: put-사용여부
        service: '/manual/service-introduction', // get-서비스 소개 자료 조회
    },
    properties: '/properties',   // get-코드 리스트, post-등록/수정/삭제
    board: '/board', // get-리스트, post-등록, delete, {id}: get-상세, put-수정
    code: '/code',  // {groupId}: get-코드 리스트, post-등록/수정/삭제
    brand: {
        base: '/brand',
        code: '/brand/code',
    },    // get-리스트 조회, post-생성, {id}: get-상세, put-수정
    terms: '/terms',    // get, post, {termsId}: get, put, /use-yn: put-약관 사용 여부
    file: {
        base: '/file',  // {fileId}: get, delete
        upload: '/file/upload', // post, head, patch - uppy
        uploadMulti: '/file/upload/multi',
        uploadItem: '/file/upload/item', // post, head, patch
        progressItem: '/file/upload/progress', // - 일반 file upload
        data: '/file/data', // post - uppy 파일 업로드 후 최종 파일 저장
        download: '/file/download', // {attachId}: get
        box: '/file/box',   // {space}/{brand}/{shop}: get
        attach: '/attach',   // {attachId}: get
    },
    system: {
        distribute: {
            list: '/deploy/manage',
            application: {
                base: '/deploy/application',
                version: '/deploy/application/ver',
                operating: '/deploy/application/operating',
                target: '/deploy/application/target',
                latest: '/deploy/application/latest',
            },
            mobile: '/deploy/mobile-version',
        }
    },
    sales: {
        meal: {
            order: {
                detail: '/meal/order/paymentDetail'
            },
            manual: { //식당 - 수기매출
                base: '/meal/order/manual', //리스트, 상세, delete
                upload: '/meal/order/manual/upload',
                validation: '/meal/order/manual/validation',
                payment: '/meal/order/manual/payment',
                download: '/meal/order/manual/excel'
            },
            etc: {
                base: '/meal-fail-order',
                excel: '/meal-fail-order/excelDownload'
            }
        }
    },
    statistics: {
        goods: {
            period: '/statistics/goods/period',
            paymentName: '/statistics/goods/paymentNm',
            orderType: '/statistics/goods/orderType',
            orderDeviceType: '/statistics/goods/orderDeviceType',
            company: '/statistics/goods/company',
            customer: '/statistics/goods/customer',
            list: '/statistics/goods/list',
            group: '/statistics/goods/group',
            excel: {
                calendar: '/statistics/goods/excel/calendar',   // 캘린더 엑셀
                customer: '/statistics/goods/excel/customer',   // 주문자별 엑셀
                customerDetail: '/statistics/goods/excel/customer-detail',   // 주문자별 엑셀 상세
                item: '/statistics/goods/excel/item',   // 항목별 엑셀
                order: '/statistics/goods/excel/order', // 리스트 엑셀
            }
        },
        meal: {
            period: '/statistics/meal/period',
            paymentName: '/statistics/meal/paymentNm',
            orderDeviceType: '/statistics/meal/orderDeviceType',
            operationTime: '/statistics/meal/operationTime',
            company: '/statistics/meal/company',
            customer: '/statistics/meal/customer',
            list: '/statistics/meal/list',
            excel: {
                calendar: '/statistics/meal/excel/calendar',   // 캘린더 엑셀
                customer: '/statistics/meal/excel/customer',   // 주문자별 엑셀
                customerDetail: '/statistics/meal/excel/customer-detail',   // 주문자별 엑셀 상세
                item: '/statistics/meal/excel/item',   // 항목별 엑셀
                order: '/statistics/meal/excel/order', // 리스트 엑셀
            }
        },
        sales: {
            goods: {
                calendar: {
                    base: '/statistics/sales/goods/calendar',
                    excel: '/statistics/sales/goods/calendar/excel'
                },
                item: {
                    bar: {
                        current: '/statistics/sales/goods/item/bar/current',
                        period: '/statistics/sales/goods/item/bar/period',
                    },
                    pie: {
                        current: '/statistics/sales/goods/item/pie/current',
                        period: '/statistics/sales/goods/item/pie/period',
                    },
                    excel: {
                        period: '/statistics/sales/goods/item/excel/period',
                    }
                },
                customer: {
                    base: '/statistics/sales/goods/customer',
                    excel: {
                        base: '/statistics/sales/goods/customer/excel',
                        detail: '/statistics/sales/goods/customer/excel/detail',
                    }
                },
                list: {
                    current: '/statistics/sales/goods/list/current',
                    period: '/statistics/sales/goods/list/period',
                    excel: '/statistics/sales/goods/list/excel',
                    currentExcel: '/statistics/sales/goods/list/current-excel',
                    goodsExcel: '/statistics/sales/goods/list/excel/product'
                }
            },
            meal: {
                calendar: {
                    base: '/statistics/sales/meal/calendar',
                    excel: {
                        sales: '/statistics/sales/meal/calendar/excel/sales',
                        operationtime: '/statistics/sales/meal/calendar/excel/operationtime',
                    },
                },
                item: {
                    bar: {
                        current: '/statistics/sales/meal/item/bar/current',
                        period: '/statistics/sales/meal/item/bar/period',
                    },
                    pie: {
                        current: '/statistics/sales/meal/item/pie/current',
                        period: '/statistics/sales/meal/item/pie/period',
                    },
                    excel: '/statistics/sales/meal/item/excel/period',
                },
                customer: {
                    base: '/statistics/sales/meal/customer',
                    excel: {
                        base: '/statistics/sales/meal/customer/excel',
                        detail: '/statistics/sales/meal/customer/excel/detail',
                    }
                },
                list: {
                    current: '/statistics/sales/meal/list/current',
                    period: '/statistics/sales/meal/list/period',
                    settlement: '/statistics/sales/meal/list/settlement',
                    excel: '/statistics/sales/meal/list/excel',
                    currentExcel: '/statistics/sales/meal/list/current-excel',
                    detail: '/meal/order/paymentDetail'
                }
            }
        },
        goodsSales: {
            goods: {
                groupRanking: {
                    base: '/statistics/goods-sales/goods/group-ranking',
                    excel: '/statistics/goods-sales/goods/group-ranking/excel',
                },
                goodsRanking: {
                    base: '/statistics/goods-sales/goods/goods-ranking',
                    excel: '/statistics/goods-sales/goods/goods-ranking/excel',
                },
                option: {
                    base: '/statistics/goods-sales/goods/option',
                    excel: '/statistics/goods-sales/goods/option/excel',
                },
                optionType: {
                    excel: '/statistics/goods-sales/goods/option-type/excel',
                }
            }
        },
        operation: {
            goods: {
                operationTime: {
                    current: '/statistics/operation/goods/operation-time/current',
                    period: '/statistics/operation/goods/operation-time/period',
                },
                timeSalesTrend: {
                    current: '/statistics/operation/goods/time-sales-trend/current',
                    period: '/statistics/operation/goods/time-sales-trend/period',
                    excel: '/statistics/operation/goods/time-sales-trend/excel',
                    productGroup: {
                        current: '/statistics/operation/goods/time-sales-trend/product-group/current',
                        period: '/statistics/operation/goods/time-sales-trend/product-group/period',
                    },
                },
                manufacturingTime: {
                    base: '/statistics/operation/goods/manufacturing-time',
                    excel: '/statistics/operation/goods/manufacturing-time/excel',
                },
                operationRecord: {
                    base: '/statistics/operation/goods/operation-record',
                    excel: '/statistics/operation/goods/operation-record/excel',
                }
            },
            meal: {
                operationTime: {
                    current: '/statistics/meal/operation-time/current',
                    period: '/statistics/meal/operation-time/period'
                },
                course: {
                    current: '/statistics/meal/course/current',
                    period: '/statistics/meal/course/period'
                },
                timeSalesTrend: {
                    current: '/statistics/operation/meal/time-sales-trend/current',
                    period: '/statistics/operation/meal/time-sales-trend/period',
                    excel: '/statistics/operation/meal/time-sales-trend/excel',
                },
                companySalesTrend: {
                    // current: '/statistics/operation/meal/time-sales-trend/current', -> timeSalesTrend와 동일한 API (request만 틀림)
                    // period: '/statistics/operation/meal/time-sales-trend/period', -> timeSalesTrend와 동일한 API (request만 틀림)
                    excel: '/statistics/operation/meal/time-sales-trend/excel-company'
                },
                operationRecord: {
                    base: '/statistics/operation/meal/operation-record',
                    excel: '/statistics/operation/meal/operation-record/excel',
                }
            }
        },
        brand: {
            goods: {
                shop: '/statistics/brand/goods/shop',
                company: {
                    base: '/statistics/brand/goods/company',
                    bar: '/statistics/brand/goods/company/bar'
                },
                customer: '/statistics/brand/goods/customer',
                excel: {
                    shop: '/statistics/brand/goods/shop/excel',
                    company: '/statistics/brand/goods/company/excel',
                    customer: {
                        base: '/statistics/brand/goods/customer/excel',
                        detail: '/statistics/brand/goods/customer/excel/detail'
                    }
                }
            },
            meal: {
                shop: '/statistics/brand/meal/shop',
                company: {
                    base: '/statistics/brand/meal/company',
                    bar: '/statistics/brand/meal/company/bar'
                },
                customer: '/statistics/brand/meal/customer',
                excel: {
                    shop: '/statistics/brand/meal/shop/excel',
                    company: '/statistics/brand/meal/company/excel',
                    customer: {
                        base: '/statistics/brand/meal/customer/excel',
                        detail: '/statistics/brand/meal/customer/excel/detail'
                    }
                }
            },
            user: {
                base: '/statistics/brand/customer',
                excel: '/statistics/brand/customer/excel'
            }
        }
    },
    dashboard: {
        cafe: {
            operation: '/dashboard/goods/operatingStatus',
            manual: '/dashboard/goods/manual',
            notice: '/dashboard/goods/notice',
            orderByTime: '/dashboard/goods/order-by-time',
            device: '/dashboard/goods/device'
        },
        dining: {
            shopState: '/dashboard/meal/shopState',
            operation: '/dashboard/meal/MealCourseOperationStatus',
            congestionStateUpdate: '/dashboard/meal/MealCourseOperationStatus/congestionType',
            courseStatus: '/dashboard/meal/MealCourseStatus',
            courseSoldOutUpdate: '/dashboard/meal/MealCourseStatus/soldOutYn',
            orderByTime: '/dashboard/meal/order-by-time',
            device: '/dashboard/meal/device',
            manual: '/dashboard/meal/manual',
            notice: '/dashboard/meal/notice'
        },
        brand: {
            usageCompany: '/dashboard/brand/usageCompany',
            notice: '/dashboard/brand/notice',
            manual: '/dashboard/brand/manual',
            usageShop: '/dashboard/brand/usageShop',
            registered: '/dashboard/brand/registered',  // 임직원 등록 현황
            graph: '/dashboard/brand/registered/graph', // 임직원 연간 등록인원 추이
        }
    },
    reward: {
        point: {
            config: '/reward/point/config',
            customer: {
                base: '/reward/point/customer',
                excel: '/reward/point/customer/excel',
                history: {
                    base: '/reward/point/customer/history',
                    excel: '/reward/point/customer/history/excel'
                }
            },
            log: {
                base: '/reward/point/log',
                detail: {
                    base: '/reward/point/log/detail',
                    excel: '/reward/point/log/detail/excel',
                }
            },
            manual: '/reward/point/manual', //PUT
            excel: {
                base: '/reward/point/excel', //PUT
                upload: '/reward/point/excel/upload', //GET, POST
                valid: '/reward/point/excel/valid', //GET, PUT
                temp: {
                    base: '/reward/point/excel/temp', //GET
                    excel: '/reward/point/excel/temp/excel' //GET
                },
            },
            auto: '/reward/point/config/auto'
        }
    }
};
